<template>
  <div class="p-1">
    <v-card :loading="loading" class="p-0" flat>
      <v-row class="pb-0 pt-4">
        <!-- ستون پیش‌نمایش کیوآر کد -->
        <v-col cols="12" md="3" style="height: fit-content">
          <v-col class="pa-0" cols="12">
            <div class="d-flex justify-center">
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <img
                v-else-if="qrSvgDataUrl"
                :src="qrSvgDataUrl"
                alt="QR Preview"
                width="100%"
              />
              <div v-else class="text-center pa-1 grey--text">
                {{ 'پیش‌نمایش در دسترس نیست' }}
              </div>
            </div>
          </v-col>
        </v-col>

        <!-- ستون تنظیمات و آکاردئون استایل‌ها -->
        <v-col cols="12" md="9">
          <div style="display: flex; flex-direction: row; justify-content: space-between;" class="mb-4">
            <span style="direction: rtl; text-align: right; color: gray;">
              {{ $t("please_click_apply_changes") || 'برای دیدن تغییرات روی اعمال کلیک کنید' }}
            </span>
            <v-btn
              :loading="loading"
              class="btn-get-code rounded-lg"
              depressed
              :disabled="!hasChanges || loading"
              @click="generatePreview"
            >
              اعمال تغییرات
              <span class="fa fa-eye ml-2" style="font-size: 15px"></span>
            </v-btn>
          </div>

          <v-col cols="12" class="pa-0" style="height: fit-content; position: sticky; top: 0">
            <v-expansion-panels
              v-model="activePanels"
              class="px-4"
              flat
              accordion
            >
              <v-expansion-panel
                v-for="(item, i) in panels"
                :key="i"
                class="mb-4"
              >
                <v-expansion-panel-header class="text-right">
                  <div class="d-flex justify-start align-center">
                    <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
                    {{ item.title }}
                  </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="py-5">
                  <component
                        :is="item.name"
                          v-model="defaultOptions"
                          :colors="colors"
                          :readonly="false"
                          :design-object="
                            item.name === 'QrCodeDotsAdv' ? designObject_patttern :
                            item.name === 'QrCodeEyeAdv' ? designObject_dots :
                            item.name === 'QrCodeSquareAdv' ? designObject_square :
                            item.name === 'QrCodeFrameAdv' ? designObject_frames :
                            item.name === 'QrCodeLogoAdv' ? designObject_logos : []
                          "
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- <div class="py-5 mt-0 col-md-12">
            <div class="rowinfo mt-0 mr-auto float-left justify-center">
              <v-btn
                color="success"
                class="submit-btn"
                @click="submitStyle"
              >
                <span class="fa fa-check ml-2" style="font-size: 15px"></span>
                {{ $t("confirm_style") || 'تایید و ذخیره استایل' }}
              </v-btn>
            </div>
          </div> -->
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
// import QrCodeMake from "./qrCodeStyle/qrCodeMake";
import axios from "axios";
import { base64ToBlob, saveOnCdnFiles } from "@/utilities/ImageGallery";
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper.vue";
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
import QrCodeFrameAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeFrameAdv";
import QrCodeLogoAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeLogoAdv";
import QrCodeDataAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDataAdv";
import QrCodeDotsAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDotsAdv";
import QrCodeEyeAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEyeAdv";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquareAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeSquareAdv";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
let qrCode = null;


export default {
  name: "QrStyleDesigner",

  components: {
    // QrCodeMake,
    QrMaker,
    QrCustomize,
    SwiperWrapper,
    QrCodeDataAdv,
    QrCodeDotsAdv,
    QrCodeEyeAdv,
    QrCodeOptions,
    QrCodeSquareAdv,
    QrCodeFrameAdv,
    QrCodeLogoAdv,
  },

  props: {
 value: {
    type: [Object, String],
    default: () => ({})
  },
      qrDataText: {
      type: String,
      default: "https://qr2.in"
    }
  },

  data() {
    return {
      hasChanges: false,
      activePanels: [0],
      loading: false,
      qrSvgDataUrl: "",
      
      designObject_dots: [],
      designObject_patttern: [],
      designObject_square: [],
      designObject_frames: [], 
      designObject_logos: [],
    
      panels: [
        { name: "QrCodeDataAdv", title: "رنگ و سایز", icon: "qrcode-edit" },
        { name: "QrCodeDotsAdv", title: "طراحی نقطه‌ها", icon: "dots-triangle" },
        { name: "QrCodeEyeAdv", title: "طراحی چشم‌ها", icon: "bullseye" },
        { name: "QrCodeSquareAdv", title: "طراحی حاشیه", icon: "rounded-corner" },
        { name: "QrCodeFrameAdv", title: "طراحی قاب", icon: "border-all" }, 
        { name: "QrCodeLogoAdv", title: "تنظیمات لوگو", icon: "image" }, 
        { name: "QrCodeOptions", title:"تنظیمات پیشرفته", icon: "cogs" },
      ],
      colors: [
        ["#649173", "#DBD5A4"], ["#B993D6", "#8CA6DB"], ["#870000", "#190A05"],
        ["#00d2ff", "#3a7bd5"], ["#DAD299", "#B0DAB9"], ["#E6DADA", "#274046"],
        ["#50C9C3", "#96DEDA"], ["#4b6cb7", "#182848"], ["#EC6F66", "#F3A183"],
        ["#5f2c82", "#49a09d"],
      ],
    defaultOptions: {
      outer_frame: "bottom",
      framelabel: "مرا اسکن کنید",
      label_font: "Parastoo.ttf",
      "label-text-size": 100,
      framecolor: "#1754ec",
      custom_frame_color: "on",

      optionlogo: "02-email-b.png",
      no_logo_bg: "on",
      logo_size: 100,
      
        different_borders_color: false,
        different_eyes_color: false,
        marker_out_color: "#000000",
        marker_in_color: "#000000",
        marker_top_right_center: "#000000",
        marker_top_right_outline: "#000000",
        marker_bottom_left_outline: "#000000",
        marker_bottom_left_center: "#000000",
        different_markers_color: false,
        width: 300,
        height: 300,
        data: "https://qr2.in",
        margin: 5,
        qrOptions: {
          typeNumber: 0,
          mode: "Byte",
          errorCorrectionLevel: "Q",
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0,
        },
        dotsOptions: {
          type: "extra-rounded",
          color: "#6a1a4c",
          gradient: null,
        },
        backgroundOptions: {
          color: "#FFFFFFFF",
          gradient: null,
        },
        image: null,
        dotsOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#6a1a4c",
            color2: "#6a1a4c",
            rotation: "0",
          },
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          gradient: null,
          color: "#690a70",
        },
        cornersSquareOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        cornersDotOptions: {
          type: "",
          color: "#b00cab",
          gradient: null,
        },
        cornersDotOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        backgroundOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#ffffff",
            color2: "#ffffff",
            rotation: "0",
          },
        },
      },

    };
  },

  watch: {
    
     defaultOptions: {
      handler(newVal) {
        this.hasChanges = true;
        this.$emit("input", this.getFormattedApiData()); 
      },
      deep: true,
    },},


  mounted() {
    if (this.value && Object.keys(this.value).length > 0) {
      let parsedValue = this.value;
      if (typeof this.value === 'string') {
        try { parsedValue = JSON.parse(this.value); } catch (e) {}
      }
      this.defaultOptions = { ...this.defaultOptions, ...parsedValue };
    }
    
    this.$emit("input", this.getFormattedApiData()); 
    this.fetchDesigns();
    this.generatePreview();
  },

  methods: {
     getFormattedApiData() {
      const opt = this.defaultOptions;
      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      return {
        param: this.qrDataText, 
        type: "url",
        number: 1,
        marker_out_color: opt.different_borders_color ? opt.marker_out_color : cornerSquare.color,
        marker_top_right_outline: opt.different_borders_color ? opt.marker_top_right_outline : cornerSquare.color,
        marker_bottom_left_outline: opt.different_borders_color ? opt.marker_bottom_left_outline : cornerSquare.color,
        marker_in_color: opt.different_eyes_color ? opt.marker_in_color : cornerDots.color,
        marker_top_right_center: opt.different_eyes_color ? opt.marker_top_right_center : cornerDots.color,
        marker_bottom_left_center: opt.different_eyes_color ? opt.marker_bottom_left_center : cornerDots.color,
        different_markers_color: opt.different_borders_color || opt.different_eyes_color,
        backcolor: backgroundColor.color,
        frontcolor: frontColor.color,
        radial: false,
        gradient: frontColor.isGradient,
        gradient_color: frontColor.color1,
        markers_color: true,
        level: opt.qrOptions?.errorCorrectionLevel || "H",
        pattern: opt.dotsOptions?.type || "default",
        marker_in:  opt.cornersDotOptions?.type || "default",
        marker_out:opt.cornersSquareOptions?.type || "default",
        outer_frame: opt.outer_frame,
        framelabel: opt.framelabel,
        label_font: opt.label_font,
        "label-text-size": opt["label-text-size"],
        framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
        custom_frame_color: opt.custom_frame_color,
        
        optionlogo: opt.optionlogo,
        no_logo_bg: opt.no_logo_bg,
        logo_size: opt.logo_size,

      };
    },
fetchDesigns() {
  this.$api.get("/v2/qr-gen/markers")
    .then(({ data }) => {
      const apiData = data.data;
      
      this.designObject_patttern = Object.keys(apiData.pattern || {}).map((key) => ({ value: key, img: apiData.pattern[key] }));
      this.designObject_dots = Object.keys(apiData.markerIn || {}).map((key) => ({ value: key, img: apiData.markerIn[key] }));
      this.designObject_square = Object.keys(apiData.markerOut || {}).map((key) => ({ value: key, img: apiData.markerOut[key] }));
      
      this.designObject_frames = Object.keys(apiData.frames || {}).map((key) => ({ 
        value: key, 
        data: apiData.frames[key] 
      }));
      
      this.designObject_logos = Object.keys(apiData.logos || {}).map((key) => ({ 
        value: key, 
        img: apiData.logos[key].preview 
      }));
    })
    .catch(() => {});
},

    generatePreview() {
      this.loading = true;
      this.hasChanges = false;
      const opt = this.defaultOptions;

      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      const apiData = {
        param: this.qrDataText, 

        type: "url",
        number: 1,
        marker_out_color: opt.different_borders_color ? opt.marker_out_color : cornerSquare.color,
        marker_top_right_outline: opt.different_borders_color ? opt.marker_top_right_outline : cornerSquare.color,
        marker_bottom_left_outline: opt.different_borders_color ? opt.marker_bottom_left_outline : cornerSquare.color,
        marker_in_color: opt.different_eyes_color ? opt.marker_in_color : cornerDots.color,
        marker_top_right_center: opt.different_eyes_color ? opt.marker_top_right_center : cornerDots.color,
        marker_bottom_left_center: opt.different_eyes_color ? opt.marker_bottom_left_center : cornerDots.color,
        different_markers_color: opt.different_borders_color || opt.different_eyes_color,
        backcolor: backgroundColor.color,
        frontcolor: frontColor.color,
        radial: false,
        gradient: frontColor.isGradient,
        gradient_color: frontColor.color1,
        markers_color: true,
        level: opt.qrOptions?.errorCorrectionLevel || "H",
        pattern: opt.dotsOptions?.type || "default",
        marker_in:  opt.cornersDotOptions?.type || "default",
        marker_out:opt.cornersSquareOptions?.type || "default",
        outer_frame: opt.outer_frame,
        framelabel: opt.framelabel,
        label_font: opt.label_font,
        "label-text-size": opt["label-text-size"],
        framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
        custom_frame_color: opt.custom_frame_color,
        
        optionlogo: opt.optionlogo,
        no_logo_bg: opt.no_logo_bg,
        logo_size: opt.logo_size,
      };

      this.$api.post("/v2/qr-gen/group", apiData)
        .then(({ data }) => {
          let r = data.data[0].content;
          this.qrSvgDataUrl = !r.includes(`data:image/svg+xml;base64,`) ? `data:image/svg+xml;base64,${r}` : r;

        })
        .finally(() => {
          this.loading = false;
          this.$emit("input", apiData);

        });
    },

    isGradient(opt) {
      if (!opt) return { isGradient: false, color: "#000000", color1: null };
      if (opt.gradient) {
        return {
          isGradient: true,
          color: opt.gradient.colorStops[0].color,
          color1: opt.gradient.colorStops[1].color,
        };
      }
      return { isGradient: false, color: opt.color, color1: null };
    },

    // این تابع کلیدواژه اصلی شماست. استایل را به کامپوننت والد می‌فرستد.
    submitStyle() {
      const opt = this.defaultOptions;

      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      const apiData = {
        param: this.qrDataText, 

        type: "url",
        number: 1,
        marker_out_color: opt.different_borders_color ? opt.marker_out_color : cornerSquare.color,
        marker_top_right_outline: opt.different_borders_color ? opt.marker_top_right_outline : cornerSquare.color,
        marker_bottom_left_outline: opt.different_borders_color ? opt.marker_bottom_left_outline : cornerSquare.color,
        marker_in_color: opt.different_eyes_color ? opt.marker_in_color : cornerDots.color,
        marker_top_right_center: opt.different_eyes_color ? opt.marker_top_right_center : cornerDots.color,
        marker_bottom_left_center: opt.different_eyes_color ? opt.marker_bottom_left_center : cornerDots.color,
        different_markers_color: opt.different_borders_color || opt.different_eyes_color,
        backcolor: backgroundColor.color,
        frontcolor: frontColor.color,
        radial: false,
        gradient: frontColor.isGradient,
        gradient_color: frontColor.color1,
        markers_color: true,
        level: opt.qrOptions?.errorCorrectionLevel || "H",
        pattern: opt.dotsOptions?.type || "default",
        marker_in:  opt.cornersDotOptions?.type || "default",
        marker_out:opt.cornersSquareOptions?.type || "default",
        outer_frame: opt.outer_frame,
        framelabel: opt.framelabel,
        label_font: opt.label_font,
        "label-text-size": opt["label-text-size"],
        framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
        custom_frame_color: opt.custom_frame_color,
        
        optionlogo: opt.optionlogo,
        no_logo_bg: opt.no_logo_bg,
        logo_size: opt.logo_size,
      };


      this.$emit("input", apiData);
      this.$emit("save", {
        options: apiData,
        previewImage: this.qrSvgDataUrl
      });
    }
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}
.v-expansion-panel >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}
.v-expansion-panel >>> .v-expansion-panel-header.v-expansion-panel-header--active .v-icon {
  color: whitesmoke !important;
}
.submit-btn {
  border-radius: 8px;
}
</style>
